import { Trans } from 'react-i18next'

import { useNextStep } from '~/shared/hooks/useNextStep'

import { QUESTION, UNIVERSITIES } from './constants'
import { ExpertsStyles as S } from './styles'

interface Props {
  nextPagePath: string
  pageId: string
}

const Experts = ({ nextPagePath, pageId }: Props) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.Title>
          <Trans i18nKey="onboarding.biologyByExperts.title" />
        </S.Title>

        <S.Subtitle>
          <Trans i18nKey="onboarding.biologyByExperts.subtitle" />
        </S.Subtitle>

        <div>
          {UNIVERSITIES.map((university, index) => (
            <S.University key={university}>
              <S.UniversityLogo>{university.charAt(0)}</S.UniversityLogo>

              <S.UniversityContent>
                <S.UniversityDegree>
                  {index === 0 ? 'University' : 'University of'}
                </S.UniversityDegree>

                <S.UniversityName>{university}</S.UniversityName>
              </S.UniversityContent>
            </S.University>
          ))}
        </div>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default Experts
